import { FormattedMessage } from 'react-intl';
import { SupportLink } from 'components/ui/atoms';
import { Alert, AlertDescription, AlertTitle } from 'components/ui/atoms/alert';
import { Error } from 'components/ui/atoms/icons/Error';
import { ErrorAlertProps } from './types';

/**
 * Alert component for order history error
 *
 * @param isVisible - whether to show alert or not
 * @returns Alert component
 */

export const ErrorAlert = ({ isVisible }: ErrorAlertProps) => {
  if (!isVisible) {
    return null;
  }

  const alertTitle = (
    <FormattedMessage
      id="order.history.alert.title"
      defaultMessage="Something went wrong."
      description="order history alert title"
    />
  );

  const alertBody = (
    <FormattedMessage
      id="order.history.alert.body"
      defaultMessage="Refresh this page and try again. If this problem persists, {supportLink}."
      description="order history alert body"
      values={{ supportLink: <SupportLink /> }}
    />
  );

  return (
    <Alert className="mb-5" variant="danger">
      <Error svgProps={{ className: 'tw-w-5 tw-h-5 tw-text-red-600' }} />
      <AlertTitle>{alertTitle}</AlertTitle>
      <AlertDescription className="tw-flex-1">{alertBody}</AlertDescription>
    </Alert>
  );
};
